<template>
  <el-row>
    <el-col :span="col_span_1" style="cursor: pointer; background-color: transparent;">
      <img  :src="logo"  style="float: left;width: 40px;height: 40px;margin-top: 10px;margin-left: 10px;"/>
      <div style="background-color: transparent;
          font-family: 'Microsoft YaHei';
          color: white; height: 60px; display: flex;
          flex-direction: column;justify-content: start; padding-left: 10px;">
        <div class="BSD_TITLE">Global Change Risk Map Platform</div>
        <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
      </div>
    </el-col>

    <!--导航条-->
    <el-col :span="col_span_2" style="background-color: transparent; text-align: right; ">
      <el-menu
        style="text-align: right;"
        :default-active="activeIndex"
        text-color="white"
        active-text-color="#ffd04b"
        background-color="#545c64"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="main" class="elMenuItem">
          <p class="GS_HeaderItem" style="text-align: center;line-height: 60px;height: 60px;background-color: transparent;margin-top: 0px;">Main</p>
        </el-menu-item>
        <el-menu-item class="elMenuItem">
          <p class="GS_HeaderItem" style="width: 10px;text-align: center;line-height: 60px;height: 60px;background-color: transparent;margin-top: 0px;">|</p>
        </el-menu-item>

        <el-submenu index="content">
          <template slot="title"><span  class="sm_title">Content</span></template>

          <el-submenu index="nm_env">
            <template slot="title"><span  class="sm_title">Environment</span></template>
            <el-menu-item index="env@world_political_map">World political map</el-menu-item>
            <el-menu-item index="env@global_satellite_image">Global satellite image</el-menu-item>
            <el-menu-item index="env@global_elevation">Global elevation</el-menu-item>
            <el-menu-item index="env@global_climate_zones">Global climate zones</el-menu-item>
            <el-menu-item index="env@global_soil">Global soil</el-menu-item>
          </el-submenu>

          <el-submenu index="nm_cc">
            <template slot="title"><span  class="sm_title">Climate Change</span></template>
            <el-menu-item index="cc@cc_tmean_mean">Temperature</el-menu-item>
            <el-menu-item index="cc@cc_prcptot_mean">Precipitation</el-menu-item>
            <el-menu-item index="cc@cc_sfcwind_mean">Wind speed</el-menu-item>
          </el-submenu>

          <el-submenu index="nm_pesc">
            <template slot="title"><span  class="sm_title" style="padding-right: 30px;">Population and Economic System Changes</span></template>
            <el-menu-item index="pesc@Population">Population</el-menu-item>
            <el-menu-item index="pesc@Gross_domestic_production">Gross domestic production</el-menu-item>
            <el-menu-item index="pesc@Global_crop_distribution">Global crop distribution</el-menu-item>
            <el-menu-item index="pesc@Global_industrial_value_added">Global industrial value added</el-menu-item>
            <el-menu-item index="pesc@Global_road_system">Global road system</el-menu-item>
            <el-menu-item index="pesc@Global_population_exposure_to_high_temperature">Global population exposure to high temperature</el-menu-item>
            <el-menu-item index="pesc@Global_population_exposure_to_rainstorm">Global population exposure to rainstorm</el-menu-item>
            <el-menu-item index="pesc@global_gdp_exposure_to_drought">Global GDP exposure to drought</el-menu-item>
            <el-menu-item index="pesc@Global_Crop_exposure_to_extremely_hightemperature">Global crop exposure to extremely high temperature</el-menu-item>
          </el-submenu>
          <el-submenu index="nm_risk">
            <template slot="title"><span  class="sm_title">Global Change Risk</span></template>
            <el-menu-item index="risk@Heatwave">Population risks</el-menu-item>
            <el-menu-item index="risk@Rice">Crop yield risks</el-menu-item>
            <el-menu-item index="risk@GDPLossRisksFlood">GDP loss risks</el-menu-item>
          </el-submenu>
        </el-submenu>

        <el-menu-item index="env" class="elMenuItem"><span class="GS_HeaderItem">Environment</span></el-menu-item>
        <el-menu-item index="cc"  class="elMenuItem"><span class="GS_HeaderItem">Climate Change</span></el-menu-item>
        <el-menu-item index="pesc" class="elMenuItem"><span class="GS_HeaderItem">Population and Economic System Changes</span></el-menu-item>
        <el-menu-item index="risk" class="elMenuItem"><span class="GS_HeaderItem">Global Change Risk</span></el-menu-item>

      </el-menu>
    </el-col>

    <el-col :span="col_span_3" style="background-color: transparent;">
      <el-dropdown v-if="loginUser!=undefined" trigger="click" style="border: none;" >
          <span class="el-dropdown-link">
            <img style="width: 28px;height: 28px; margin-top: 17px;" src="../../../assets/icons/defaule_avatar.png">
          </span>
        <el-dropdown-menu slot="dropdown" style="background-color: white;">
          <el-dropdown-item>
            <div style="width:150px; background-color: transparent" @click="switchFeedback"><i class="el-icon-s-comment"></i>Feedback</div>
          </el-dropdown-item>
          <div style="width: 80%; height: 1px; background-color: red;margin-left: 10%;margin-top: 10px;margin-bottom: 10px;background-color: lightgrey;"></div>
          <el-dropdown-item ><div style="width:150px; background-color: transparent" @click="loginOut"><i class="el-icon-s-fold"></i> Logout</div></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-else style="background-color: transparent; height: 60px; width: 80px; cursor: pointer;" @click="Login()">
        <span class="el-dropdown-link" ><img style="width: 28px;height: 28px; margin-top: 17px;" src="../../../assets/icons/defaule_avatar.png"></span>
      </div>
    </el-col>

  </el-row>
</template>

<script>
let bsd_logo =  require('../../../assets/icons/earth.png');
export default {
  name: "NavHeader",
  props:{
    activeIndex: {
      type: String,
      default: "main"
    },
  },
  data(){
    return {
      logo: bsd_logo,
      loginUser:undefined,
      col_span_1:6,
      col_span_2:17,
      col_span_3:1,
    }
  },
  created() {
    this.loginUser = this.$appStorage.getUserMailbox();
  },
  methods:{
    handleSelect(key, keyPath) {
      if(key.indexOf("@")>-1) {
        let keys = key.split("@");
        let routr = keys[0];
        let params = keys[1];
        console.log("key= ",key);
        let rPath = "/BNUMap/"+routr+"?sm="+params;
        this.$router.push({path:rPath})
      }else {
        if(key!=undefined && key!=null){
          switch (key) {
            case "env":
              key = key+"?sm=world_political_map";
              break;
            case "cc":
              key = key+"?sm=cc_tmean_mean";
              break;
            case "pesc":
              key = key+"?sm=Population";
              break;
            case "risk":
              key = key+"?sm=Heatwave";
              break;
          }
          let rPath = "/BNUMap/"+key;
          this.$router.push({path:rPath})
        }
      }
    },

    Login(){
      let userData = this.$appStorage.getUserData();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        alert(JSON.stringify(userData));
      }
    },
    loginOut() {
      this.$confirm('Do you want to log out?', 'Prompt', {
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        //清除缓存，修改登录状态
        this.$appStorage.userLogout();
        this.loginUser = this.$appStorage.getUserMailbox();
      })
    },

  },
}
</script>

<style scoped>
.BSD_TITLE{
  margin-top: 12px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}
.BSD_SUBTITLE{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}

.el-menu-demo
{
  width: auto;
  background-color: transparent;
  text-align: right;
  float: right;
}


.elMenuItem{
  padding-left:10px;
  padding-right:10px;

}

.GS_HeaderItem{
  font-size: 1.5rem;
  /*font-weight: bold;*/
}

.sm_title{
  /*font-weight: bold;*/
  font-family: "Microsoft YaHei";
}

</style>



// WEBPACK FOOTER //
// src/view/BSD/components/NavHeader.vue